<div class="p-inputgroup p-mb-2">
    <input #emailInput id="email" type="text" pInputText placeholder="Username" aria-describedby="email-help" autocorrect="off" 
        spellcheck="false" autocomplete="off" pattern="[A-Za-z0-9@.-]{3,}" [(ngModel)]="email">   
    <button type="button" pButton pRipple label="Add User" (click)="createUser(emailInput.value);"
        [disabled]="email.length == 0 || !emailInput.validity.valid || creatingUser">
    </button>
</div>
<small *ngIf="email.length > 2 && !emailInput.validity.valid">Use only letters and numbers, with a minimum of 3 characters</small>
<p-table [value]="users" dataKey="uid" responsiveLayout="scroll">
    <ng-template pTemplate="header">
        <tr>
            <th style="width:350px">Username</th>
            <th>Role</th>
            <th>Reset Password</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
        <tr>
            <td>{{user.email}}</td>
            <td pEditableColumn>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <p-dropdown #roleDropdown [options]="roles" [ngModel]="user.role" (onChange)="setRole(user, roleDropdown, $event)"></p-dropdown>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{user.role ? user.role : 'user'}}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td><button #resetButton class="mybutton" style="padding: 8px 12px;" (click)="resetPassword(user, resetButton)">Reset</button></td>
            <td style="text-align:right">
                <button pButton pRipple type="button" icon="pi pi-times" (click)="deleteUser(user.uid, $event)" class="p-button-rounded p-button-text"></button>
            </td>

        </tr>
    </ng-template>
</p-table>

<p-confirmPopup></p-confirmPopup>
<p-toast position="bottom-center"></p-toast>